module.exports = __webpack_public_path__ + "img/85e5baf.png";